import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Select, Card, Row, Col, DatePicker, Descriptions, InputNumber, Modal, notification, Spin, Switch, Radio, message } from 'antd';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { SaleOrderService } from '@gtpl/shared-services/sale-management'
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { EndCustomersService, HrmsEmpDetService, MasterBrandService, PackingMethodService, ProductService, RackPositionService, RackService, SizesService, SkuService, UnitcodeService, ZoneService } from '@gtpl/shared-services/masters';
import { FGStockService, ForkLiftJobService, StockInService } from '@gtpl/shared-services/warehouse-management'
import { ProductionInventoryService } from '@gtpl/shared-services/production'
import './stock-in-form.css';
import moment from 'moment';
import { CategoriesInput, ForkliftJobcodesDropDownDto, ItemsDetails, PackTypeCategory, SaleOrderDetailViewInfoDTO, SaleOrderDropDownDto, SaleOrderItemsDTO, SaleOrderItemsInfo, UnitsOfWeightInput } from '@gtpl/shared-models/sale-management';
import { CusAddressInfo, ProductDto, RackDropDownDto, SizesDropDownDto, SkuDto, ZoneDropDownDto, GetValueAdditionDataBySkuCodesRequest, Brands, UnitcodeDto, RackSuggestionResponseDto, RackDropDownResponseModel, HrmsEmployeeDetailsDto, PackingMethodDto } from '@gtpl/shared-models/masters';
import { FgStatusEnum, FreezerTypesEnum, GlobalVariableValues, JobTypesEnum, OperationTypeEnum, PackingStatus, PalletType, ProductCategoryDropDown, ProductCategoryEnum, ShiftsDropDown, ShiftsEnum, StockTypeDropDown, stockTypeEnum, StockTypesEnum, StockTypeStatus, TransactionType, TransactionTypeDropDown, UnitRequest } from '@gtpl/shared-models/common-models';
import { CheckSoItemExistReq, FgStockStatusEnum, ForkLiftJobRequestDTO, JobIdRequest, SOVarientIdReq, SaleOrderIdRequest, StockInDto, StockInRequestDto } from '@gtpl/shared-models/warehouse-management';
import { LotAndOperationReq, LotCodeDropDown, LotInformationRequest, VarientIdRequest } from '@gtpl/shared-models/production-management';
import { RMGrnService } from '@gtpl/shared-services/raw-material-procurement';
import { SizesForm } from '@gtpl/pages/master/master-components/sizes-form';

import { LotCodesDTO } from '@gtpl/shared-models/raw-material-procurement';
import ItemDetailsForm from './item-details';
import { BrandsInfo } from 'libs/shared-models/masters/src/lib/endCuctomer/brands-model';
import {CodeListMainService} from '@gtpl/shared-services/planning';
import TextArea from 'antd/lib/input/TextArea';
import StockinPrint from './stock-in-print';
import { StockStatus } from 'apps/services/warehouse-service/src/app/stock/dto/stock-status.enum';
import { WarehouseDashboardService } from "@gtpl/shared-services/analytics"
import Table, { ColumnProps } from 'antd/lib/table';
import {RightSquareOutlined} from '@ant-design/icons';


const { Option } = Select;

/* eslint-disable-next-line */
export interface StockInFormProps { }

export function StockInForm(
  props: StockInFormProps
) {

  let stockType = StockTypeDropDown;
  let transactionTypeDropDown = TransactionTypeDropDown.filter(e => {return(e.name != 'Complements')});
  let shifts = ShiftsDropDown;
  let history = useHistory();
  let categories = ProductCategoryDropDown;
  let forkliftJobcodesDropDownDto =ForkliftJobcodesDropDownDto;
  const [form] = Form.useForm();
  const [hideColumns, setHideColumns] = useState<boolean>(false)
  const [hidePackStyle, setHidePackStyle] = useState<boolean>(false)
  const [hidejobType,setHidejobType] = useState<boolean>(true)
  const [itemValidation, setItemValidation] = useState<boolean>(false)
  const [hideRackColumns, setHideRackColumns] = useState<boolean>(false)
  const [isUpdate, setIsUpdate] = useState<boolean>(false)
  const [saleOrderId, setSaleOrderId] = useState<number>(undefined)
  const [jobId,setJobId] = useState<number>(undefined)
  const [jobCode,setJobCode] = useState<string>(undefined)
  const [employeeData, setEmployeeData] = useState<HrmsEmployeeDetailsDto[]>([]);
  const [packStyle, setPackStyle] = useState<PackingMethodDto[]>([]);
  const [stockStatus, setStockStatus] = useState<string>(undefined)
  const [saleOrderItemDetails, setSaleOrderItemDetails] = useState<SaleOrderItemsDTO>(undefined)
  const [saleOrderItemsData, setSaleOrderItemsData] = useState<ItemsDetails[]>([])
  const [saleOrderData, setSaleOrderData] = useState<SaleOrderDropDownDto[]>([])
  const [traceCodeList, setTraceCodeList] = useState<any[]>([])
  const [jobcodesData,setJobcodesData] = useState<ForkliftJobcodesDropDownDto[]>([])
  const [rackPostionsDropDown, setRackPostionsDropDown] = useState<any[]>([])
  const [zoneDropDown, setZoneDropDown] = useState<ZoneDropDownDto[]>([])
  const [saleOrderDetails, setSaleOrderDetails] = useState<SaleOrderDetailViewInfoDTO>(undefined)
  const [saleOrderItemsDetails, setSaleOrderItemsDetails] = useState<SaleOrderItemsDTO[]>(undefined)
  const [itemDetailsGridData, setItemDetailsGridData] = useState<any>(undefined)
  const [masterBrandData, setMasterBrandData] = useState<any>(undefined)
  const [varientId, setVarientId] = useState<number>(undefined)
  const [customerBrandsData, setCustomerBrandsData] = useState<BrandsInfo[]>([]);
  const [selectedCategory, setSelectedCategory] = useState<string>('');
  const [selectedCurrency, setSelectedCurrency] = useState<number>(1);
  const [itemsKey, setItemsKey] = useState<number>(10);
  const [lotCodesDropDown, setLotCodesDropDown] = useState<string>(undefined)
  const [plantInfo, setPlantInfo] = useState<UnitcodeDto>(undefined)
  const [btnDisable, setBtnDisable] = useState<boolean>(false);
  const [isJobcodeRequired,setIsJobcodeRequired] = useState<boolean>(false);
  const [isTracecodeRequired,setIsTracecodeRequired] = useState<boolean>(true);
  const [isModalVisible,setIsModalVisible] = useState<boolean>(false);
  const [modalName,setModalName] = useState<string>('')
  const unitcodeService = new UnitcodeService();
  const saleOrderService = new SaleOrderService();
  const packingMethodService = new PackingMethodService();
  const zoneService = new ZoneService();
  const rackService = new RackService();
  const rackPositionService = new RackPositionService();
  const sizeService = new SizesService();
  const endcustomerservice = new EndCustomersService();
  const stockInService = new StockInService();
  const rMGrnService = new RMGrnService();
  const masterBrandService = new MasterBrandService();
  const forkliftService = new ForkLiftJobService();
  const codeListMainService = new CodeListMainService();
  const employeeService = new HrmsEmpDetService();
  const [reportingLogId,setReportingLogId] = useState<any>()
  const [value, setValue] = React.useState(0);
  const [lotCodes, setLotCodes] = useState<any>([])
  const [products,setProducts] = useState<any[]>([])
  const [dummyProductPackStyles,setDummyProductPackStyles] = useState<any[]>([])
  const [saveFlag,setsaveFlag] = useState<boolean>(true)
  const [productPackStyleRequiredStatus,setproductPackStyleRequiredStatus] = useState<boolean>(false)
  const warehouseService = new WarehouseDashboardService()
  const [todayStockInInfo,setTodayStockInInfo] = useState<any[]>([])
  const [page,setPage] = useState<number>(1)
  const [prevReportedQty,setPrevReportedQty] = useState<number>()
  const [unitCodes,setUnticodes] = useState<any[]>([])
  const [stockTypeDisable,setStockTypeDisable] = useState<boolean>(false)
  const [year,setYear] = useState<number>()
  const [lotRequiredState,setLotRequiredState] = useState<boolean>(true)
  const [stockTransferSoInfo,setStockTransferSoInfo] = useState<any[]>([])
  const [selectedProductcategory,setSelectedProductCategory] = useState<ProductCategoryEnum>(ProductCategoryEnum.GI)
  const productionInvService = new ProductionInventoryService()
  const [rejectionFromProducts,setRejectionFromProducts] = useState<any[]>([])
  const [gradeChange,setGradeChange] = useState<boolean>(false)
  const [soakingOutProducts,setSoakingOutProducts] = useState<any[]>([])

  let location = useLocation();
  let data: any = location.state;
  useEffect(() => {
    console.log(data);
    if(data != undefined){
      form.setFieldsValue({'unitId': data.unitId})
      form.setFieldsValue({'plantId': data.unitId})
      form.setFieldsValue({'transactionType': data.jobPurpose});
      const unitId = GlobalVariableValues.productionVersion == 'V1' ? localStorage.getItem("unit_id") : form.getFieldValue('unitId') 
      getJobsList(data.jobPurpose)
      if(data.jobPurpose == TransactionType.reprocessing){
        getSOsAgainstJob(data.jobId,data.jobPurpose);
        getReportedQtyAgainstJob(data.jobId)
      }else if (data.jobPurpose == TransactionType.Labsamples){
        getDummySaleOrdersData(unitId);
      }else{
        getSaleOrderData(unitId)
      }
      if(data.jobPurpose != TransactionType.Labsamples){
        setStockTypeDisable(true)
        form.setFieldsValue({'saleOrderId': data.saleOrderId});
        handleSaleOrder(data.saleOrderId);
      }else{
        setStockTypeDisable(false)
        form.setFieldsValue({'stockStatus' : StockTypeStatus.dummy})
      }
      form.setFieldsValue({'jobId': data.jobId});
      form.setFieldsValue({'reportingCases': 0});
      setJobId(data.jobId);
      setJobCode(data.jobCode)
      
    }
  },[data])

  const getSoakingOutProductsInfo = () => {
    const req = new LotAndOperationReq(form.getFieldValue('lotCode'),null,null,form.getFieldValue('unitId'),year)
    productionInvService.getSoakingOutProducts(req).then(res => {
      if(res.status){
        setRejectionFromProducts(res.data)
      }else{
        setRejectionFromProducts([])
      }
    })
  }

  const getRejectionFromProductsInfo = () => {
    const req = new LotAndOperationReq(form.getFieldValue('lotCode'),null,null,form.getFieldValue('unitId'),year)
    productionInvService.getRejectionFromProducts(req).then(res => {
      if(res.status){
        setRejectionFromProducts(res.data)
      }else{
        setRejectionFromProducts([])
      }
    })
  }

  const getProductsAgainstLotCount = () => {
    let lot
    if(form.getFieldValue('transactionType') == TransactionType.rm || form.getFieldValue('transactionType') == TransactionType.productPurchase){
      lot = form.getFieldValue('lotCode')
    }else{
      lot = jobCode
    }
    if(lot != undefined && form.getFieldValue('unitId') != undefined && form.getFieldValue('gradeChange') == true){
      const req = new LotAndOperationReq(lot,OperationTypeEnum.SOAKING,undefined,form.getFieldValue('unitId'),year)
      productionInvService.getProductsAgainstLotCount(req).then(res => {
        if(res.status){
          setSoakingOutProducts(res.data)
        }else{
          setSoakingOutProducts([])
        }
      })
    }
  }

  const getAllMainPlants = () => {
    unitcodeService.getAllMainPlants().then((res) => {
      if (res.status) {
        setUnticodes(res.data);
      } else {
        setUnticodes([]);
      }
    }).catch((err) => {
      AlertMessages.getErrorMessage(err.message);
      setUnticodes([]);
    });
  }

  const getReportedQtyAgainstJob = (jobId) => {
    const req= new JobIdRequest(jobId,null)
    warehouseService.getReportedQtyAgainstJob(req).then(res => {
      if(res.status){
        setPrevReportedQty(res.data[0].quantity)
      }
    })
  }

  let createdUser = '';
  createdUser = localStorage.getItem('createdUser');
  let plant = '';
  plant = localStorage.getItem('unit_id');

  useEffect(() => {
    console.log(form.getFieldsValue());

    // getRacks(undefined);
    // getPlantById(plant);
    if(plant === "3" || plant === "2"){
      setHideRackColumns(true);
    }
    else{
      setHideRackColumns(false);
    }
    if(data != undefined && data?.jobPurpose != TransactionType.Labsamples){
      form.setFieldsValue({stockStatus:StockTypeStatus.SaleOrder});
    }
    form.setFieldsValue({ packingCompleted: PackingStatus.YES })
    form.setFieldsValue({pouchesShortage : PackingStatus.NO})
    form.setFieldsValue({cartonsShortage : PackingStatus.NO})
    form.setFieldsValue({productCategory : ProductCategoryEnum.GI})
    setSelectedProductCategory(ProductCategoryEnum.GI)
    setHideColumns(false);
    setItemValidation(true);
    if(GlobalVariableValues.productionVersion == 'V1' || data != undefined){
      console.log('****************************************')
      const unitId = form.getFieldValue('unitId') != undefined ? form.getFieldValue('unitId') : localStorage.getItem("unit_id")
      if(data?.jobPurpose == TransactionType.Labsamples){
        getDummySaleOrdersData(unitId)
      }else{
        getSaleOrderData(unitId);
      }
      getPackStyles(unitId);
    }
    // getZones(); commented zones service bcz dropdown is hidden
    getWarehousePersonsData()
    // getLotCodes(localStorage.getItem("unit_id"));
    // getItemsData();
    // getSkuCodes();
    // getSizes()
    getRacks(undefined); //reserve logic commented
    getLots()
    getTodayStockinInfo()
    getAllMainPlants()

  }, []);

  const getTodayStockinInfo = () => {
    const unitId = form.getFieldValue('unitId') != undefined ? form.getFieldValue('unitId') : localStorage.getItem('unit_id') 
    const req = new UnitRequest(unitId)
    warehouseService.getTodayStockInInfo(req).then(res => {
      if(res.status){
        setTodayStockInInfo(res.data)
      }else{
        setTodayStockInInfo([])
      }
    })
  }

  
  const columns : ColumnProps<any>[] = [
    {
        title: 'S No',
        key: 'sno',
        width: '70px',
        responsive: ['sm'],
        render: (text, object, index) => (page - 1) * 10 + (index + 1)
    },
    {
      title:'Reported Date',
      dataIndex:'reportedDate',
      render:(text,record) => {
        return(
          <>
          {record.reportedDate ? moment(record.reportedDate).format('YYYY-MM-DD') : '-'}
          </>
        )
      }
    },
    {
      title:'Transaction Type',
      dataIndex:'transactionType'
    },
    {
      title:'Stock Type',
      dataIndex:'stockType'
    },
    {
      title:'Customer PO',
      dataIndex:'poNumber'
    },
    {
      title:'Product',
      dataIndex:'shortCode'
    },
    {
      title:'LotCode',
      dataIndex:'lotCode'
    },
    {
      title:'MC',
      dataIndex:'masterCartons'
    },
    {
      title:'Loose Pouches',
      dataIndex:'loosePouches'
    },
  ]

  const getLots = () =>{
rMGrnService.getPlantLotNumbers().then((res)=>{
  if(res.status){
    setLotCodes(res.data)
  }
})
  }
  const getPackStyles = (unitId) => {
    packingMethodService.getAllActivePackingMethods().then((res) => {
      if (res.status) {
        setPackStyle(res.data);
      } else {
        // if (res.intlCode) {
        //   AlertMessages.getErrorMessage(res.internalMessage);
        // } else {
        //   AlertMessages.getErrorMessage(res.internalMessage);
        // }
        setPackStyle([]);
      }
    }).catch((err) => {
      AlertMessages.getErrorMessage(err.message);
      setPackStyle([]);
    });
  }

  const getWarehousePersonsData = () => {
    employeeService.getActiveEmployeesByDept({employeeDept:"warehouse"}).then((res) => {
      if (res.status) {
        setEmployeeData(res.data);
      } else {
        // if (res.intlCode) {
        //   AlertMessages.getErrorMessage(res.internalMessage);
        // } else {
        //   AlertMessages.getErrorMessage(res.internalMessage);
        // }
        setEmployeeData([]);
      }
    }).catch((err) => {
      AlertMessages.getErrorMessage(err.message);
      setEmployeeData([]);
    });
  }

  const addDataToItemDetails = (itemDetalFormdata) => {
    // console.log(itemDetalFormdata)
    setItemDetailsGridData(itemDetalFormdata)
    setIsUpdate(true);
  }

  const handleVarientId = (val) => {
    // console.log(val);
    setVarientId(val)
    // getRacks(val); //reserve logic commented
  }
  const mastesrBrandData = (masterBrand) => {
    // console.log(masterBrand);
    setMasterBrandData(masterBrand);


  }
  const getPlantById = (value) => {
    unitcodeService.getPlantDetailsById({unitcodeId:value}).then(res => {
      if (res.status) {
        // console.log(res.data);
        setPlantInfo(res.data);
        if(res.data.unitcodeId === 3){
          setHideRackColumns(true);
        }
      }
      else {
        setPlantInfo(undefined);
        setHideRackColumns(false);

      }
    }).catch((err) => {
      AlertMessages.getErrorMessage(err.message);
      setPlantInfo(undefined);
      setHideRackColumns(false);

    });
  }
  const getLotCodes = (value) => {
    rMGrnService.getAllLotCodes({ unitcodeId: value }).then(res => {
      if (res.status) {
        setLotCodesDropDown(res.data[0].lotCode);
        form.setFieldsValue({ lotCode: res.data[0].lotCode })
        // getSaleOrderData();
      }
      else {
        setLotCodesDropDown(undefined);
      }
    }).catch((err) => {
      AlertMessages.getErrorMessage(err.message);
      setLotCodesDropDown(undefined);
    });
  }
  const getendCustomerAddress = (value) => {
    if(form.getFieldValue("stockStatus") === "anticipated"){
      endcustomerservice.getAllActiveBrands().then((res) => {
        if (res.status) {
          setCustomerBrandsData(res.data);
        } else {
          // if (res.intlCode) {
          //   AlertMessages.getErrorMessage(res.internalMessage);
          // } else {
          //   AlertMessages.getErrorMessage(res.internalMessage);
          // }
          setCustomerBrandsData([]);
        }
      }).catch((err) => {
        AlertMessages.getErrorMessage(err.message);
        setCustomerBrandsData([]);
      });
    }
    else{
      endcustomerservice.getEndCustomerDataById({endCustomerId:value,isActive:true}).then((res) => {
        if (res.status) {
          setCustomerBrandsData(res.data.brandsInfo);
        } else {
          // if (res.intlCode) {
          //   AlertMessages.getErrorMessage(res.internalMessage);
          // } else {
          //   AlertMessages.getErrorMessage(res.internalMessage);
          // }
          setCustomerBrandsData([]);
        }
      }).catch((err) => {
        AlertMessages.getErrorMessage(err.message);
        setCustomerBrandsData([]);
      });
    }
    
  }
  
  const getSaleOrderDetails = (reqData) => {
    // console.log("is it calling")
    saleOrderService.getSaleOrderDetailsById({ saleOrderId: reqData }).then(res => {
      if (res.status) {
        // console.log(res.data);
        setSaleOrderDetails(res.data);
        // (res.data.itemData).filter(rec => ((moment(rec.createdAt).format("YYYY-MM-DD")) === (moment().format("YYYY-MM-DD")))?
        // setSaleOrderItemsDetails(rec):setSaleOrderItemsDetails(undefined))
        setSaleOrderItemsDetails(res.data.itemData)
        if(res.data.itemData.length === 1){
          form.setFieldsValue({saleOrderItemId:res.data.itemData[0].saleOrderItemId});
        }
        setItemsKey(preStateval => preStateval + 10);
        setSelectedCategory(res.data.category);
        setSelectedCurrency(res.data.currencyId);
        // getRacks(undefined) //reserve logic commented
        // if(res.data.category === PackTypeCategory.SKEWERS){
        //   setIsInnerBagsHidden(false)
        //   setIsInnerBagsizeHidden(false)
        // }
        // checkItemExist(res.data.itemData);
        getendCustomerAddress(res.data.endCustomerId)
      } else {
        if (res.intlCode) {
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
        setSaleOrderDetails(undefined);
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
      setSaleOrderDetails(undefined);
    })
  }
  const getZones = () => {
    zoneService.getAllZoneDropDown().then((res) => {
      if (res.status) {
        // console.log(res.data);
        setZoneDropDown(res.data);
      } else {
        if (res.intlCode) {
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
        setZoneDropDown([]);
      }
    }).catch((err) => {
      AlertMessages.getErrorMessage(err.message);
      setZoneDropDown([]);
    });
  }
  const getRacks = (variantId) => {
    console.log("GetRacksService")
    setRackPostionsDropDown([])
    console.log(setRackPostionsDropDown)
    // form.setFieldsValue({rackPostion : null})
    let saleOrderId = form.getFieldValue("saleOrderId");
    let saleOrderItemId = form.getFieldValue("saleOrderItemId");
    let reportingCases = form.getFieldValue("reportingCases");
    // let packStyle = form.getFieldValue("packStyleId");
    let packStyle = form.getFieldValue("packStyleId");
    let stockStatus = form.getFieldValue("stockStatus");
    let plantId = GlobalVariableValues.productionVersion == 'V1' ? Number(localStorage.getItem("unit_id")) : form.getFieldValue('unitId');
    console.log(packStyle);
    if(plantId != undefined && saleOrderId != undefined && saleOrderItemId != undefined && reportingCases != undefined && stockStatus != undefined){
      console.log(plantId);
        // {plantId!=2?form.setFieldsValue({rackPostion : undefined}):""} commented bcz the change is need to empty rack position when change PO for unit one plant also
        form.setFieldsValue({rackPostion : undefined})
        rackPositionService.getAvailableRackPositionsForPlantId({plantId:plantId,saleOrderId:saleOrderId,saleOrderItemId:saleOrderItemId,mastersCartons:reportingCases,stockTypeStatus:stockStatus,varientId:undefined,packStyleId:packStyle}).then((res) => {
          if (res.status) {
            console.log(res.data)
            setRackPostionsDropDown(res.data);
          }
          else {
            if (res.intlCode) {
              AlertMessages.getErrorMessage(res.internalMessage);
              setRackPostionsDropDown([]);
            } else {
              setRackPostionsDropDown([]);
              AlertMessages.getErrorMessage(res.internalMessage);
            }
          }
        }).catch((err) => {
            AlertMessages.getErrorMessage(err.message);
            setRackPostionsDropDown([]);
        });
    }
    // console.log(variantId);
    // console.log(form.getFieldsValue());
    // console.log(plantId+"***" +saleOrderId+"***" + saleOrderItemId+"***"+reportingCases+"***"+stockStatus+"*****"+variantId);
    // if(stockStatus === stockTypeEnum.SaleOrder){
      // if(plant === "2"){
      //   rackPositionService.getUnit1RackPositions({plantId:plantId}).then(res =>{
      //     if (res.status) {
      //       setRackPostionsDropDown(res.data);
      //     }
      //     else {
      //       if (res.intlCode) {
      //         AlertMessages.getErrorMessage(res.internalMessage);
      //         setRackPostionsDropDown([]);
      //       } else {
      //         setRackPostionsDropDown([]);
      //         AlertMessages.getErrorMessage(res.internalMessage);
      //       }
      //     }
      //   }).catch((err) => {
      //       AlertMessages.getErrorMessage(err.message);
      //       setRackPostionsDropDown([]);
      //   });
        
      // }
      // reserve & suggestion from 383 to 409
      // else{
      //   if((plantId != undefined && saleOrderId != undefined && saleOrderItemId != undefined && reportingCases != undefined && reportingCases > 0 && stockStatus != undefined) || variantId != undefined){
      //     // console.log("hi");
      //     rackPositionService.reserveRackPosition({plantId:plantId,saleOrderId:saleOrderId,saleOrderItemId:saleOrderItemId,mastersCartons:reportingCases,stockTypeStatus:stockStatus,varientId:variantId,packStyleId:packStyle, role:((localStorage.getItem("role")).replace(/"|"/, '')).replace('"',"")}).then(res => {
      //       if (res.status) {
      //         // console.log(res);

      //         openReserveNotification(res.data1);
      //         setRackPostionsDropDown(res.data);
      //         form.setFieldsValue({rackPostion : res.data[0]?.rackPositionId})
      //         form.setFieldsValue({coldStorageId : res.data[0]?.zoneId})
      //       }
      //     else {
      //       if (res.intlCode) {
      //         AlertMessages.getErrorMessage(res.internalMessage);
      //         setRackPostionsDropDown([]);
      //       } else {
      //         setRackPostionsDropDown([]);
      //         AlertMessages.getErrorMessage(res.internalMessage);
      //       }
      //     }
      //     }).catch((err) => {
      //       AlertMessages.getErrorMessage(err.message);
      //       setRackPostionsDropDown([]);
      //     });
      //   }
      // }

    // }
    // else{
    //   rackPositionService.getRackPositionsForDummy({plantId:Number(localStorage.getItem("unit_id")),varientId:varientId}).then(res => {
    //     if(res.status){
    //       setRackPostionsDropDown(res.data);
    //     }
    //     else {
    //       if (res.intlCode) {
    //         setRackPostionsDropDown([]);
    //         AlertMessages.getErrorMessage(res.internalMessage);
    //       } else {
    //         setRackPostionsDropDown([]);
    //         AlertMessages.getErrorMessage(res.internalMessage);
    //       }
    //     }
    //   }).catch((err) => {
    //     AlertMessages.getErrorMessage(err.message);
    //     setRackPostionsDropDown([]);
    //   });
    // }
    // }
  }
  console.log(reportingLogId,'props')
  const getDummySaleOrdersData = (value) => {
    saleOrderService.getDummySaleOrders({ plantId: value }).then((res) => {
      if (res.status) {
        // console.log(res.data);
        setSaleOrderData(res.data);
      } else {
        if (res.intlCode) {
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
        setSaleOrderData([]);
      }
    }).catch((err) => {
      AlertMessages.getErrorMessage(err.message);
      setSaleOrderData([]);
    });
  }
  const getSaleOrderData = (value) => {
    saleOrderService.getMTOSaleOrders({ plantId: value }).then((res) => {
      if (res.status) {
        // console.log(res.data);
        setSaleOrderData(res.data);
      } else {
        if (res.intlCode) {
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
        setSaleOrderData([]);
      }
    }).catch((err) => {
      AlertMessages.getErrorMessage(err.message);
      setSaleOrderData([]);
    });
  }
  const getSaleOrderItems = (reqData) => {
    if(reqData > 0){

      // console.log("item details service");
      setSaleOrderItemDetails(undefined);
      setSaleOrderItemsData([]);
      let req = new SaleOrderIdRequest(reqData)
      console.log(form.getFieldValue('productId'))
     
      if(form.getFieldValue('stockStatus') == StockTypeStatus.dummy){
        req.packStyleId = form.getFieldValue('packMethodId')
        req.productId = form.getFieldValue('productId')
      }
      if(form.getFieldValue('transactionType') == TransactionType.stockTransfer){
        req.productIdArray = stockTransferSoInfo[0].variantId
      }
      // if(data){
      //   req.productId = data.variantId
      // }
      saleOrderService.getSaleOrderItemsForSoId(req).then(res => {
        if (res.status) {
          // console.log(res.data.length);
          if(form.getFieldValue('stockStatus') == StockTypeStatus.dummy){
            if(res.data.length > 1){
              setsaveFlag(false)
              AlertMessages.getErrorMessage('More than 1 product is there for selected product and pack style and customer po')
            }else{
              setsaveFlag(true)
            }
          }
          setSaleOrderItemsData(res.data);
          if(form.getFieldValue('stockStatus') === "anticipated" || form.getFieldValue('stockStatus') === "dummy"){
            getendCustomerAddress(res.data[0].endCustomerId)
          }
          else if(form.getFieldValue('stockStatus') === "superDummy"){
            form.setFieldsValue({'packStyleId': res.data[0].packStyleId});
            // form.setFieldsValue({'reportingCases': packStyle.find(rec => rec.packingMethodId === res.data[0].packStyleId).maxPalletCapacity});
          }
          
          if(res.data.length === 1){
            console.log('okkk')
            // console.log(reqData)
            form.setFieldsValue({ saleOrderItemId: res.data[0].saleOrderItemId });
            setSaleOrderId(reqData);
            getSaleOrderItemDetails(res.data[0].saleOrderItemId);
            getRacks(undefined); //reserve logic commented
          }
          else{
            console.log('else')
            form.setFieldsValue({ saleOrderItemId: null });
          }
        } else {
          if (res.intlCode) {
            AlertMessages.getErrorMessage(res.internalMessage);
          } else {
            AlertMessages.getErrorMessage(res.internalMessage);
          }
          setSaleOrderItemsData([]);
        }
      }).catch(err => {
        AlertMessages.getErrorMessage(err.message);
        setSaleOrderItemsData([]);
      })
    }
  }
  const getcheckPalletCapacity = (reqData,stockStatus,varient) => {
    // console.log(reqData);
    packingMethodService.getPalletCapacity({noOfPouches:reqData.pouches,pouchesPerRow:reqData.pouchWeight,uomId:reqData.uomId}).then(res => {
      if(res.status){
        // form.setFieldsValue({ reportingCases: res.data.palletCapacity });
        if(stockStatus === "dummy"){
          getRacks(varient) //reserve logic commented
        }
        else{
          getRacks(undefined) //reserve logic commented
        }
      }
      else {
        if (res.intlCode) {
          // console.log("hi")
          form.setFieldsValue({ reportingCases: 0 });
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          form.setFieldsValue({ reportingCases: 0 });
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
      setSaleOrderItemsData([]);
    })
  }
  const getSaleOrderItemDetails = (reqData) => {
    form.setFieldsValue({'saleOrderItemId' : Number(reqData)})
    // console.log(saleOrderId)
    // console.log(reqData)
    // setSaleOrderItemDetails(undefined);
    saleOrderService.getSaleOrderItemDetails({ saleOrderId: form.getFieldValue("saleOrderId"), saleOrderItemId: reqData, stockType: form.getFieldValue("stockStatus") }).then(res => {
      if (res.status) {
        console.log(res.data);
        setSaleOrderItemDetails(res.data);
        form.setFieldsValue({'packStyleId':res.data.packStyleId});
        if(Number(localStorage.getItem('unit_id')) != 2 && form.getFieldValue("stockStatus") != "superDummy"){
          if(form.getFieldValue('transactionType') == TransactionType.stockTransfer){
            // form.setFieldsValue({reportingCases: stockTransferSoInfo[0].jobCartons })
            // form.setFieldsValue({loosePouches: stockTransferSoInfo[0].jobLoosePouches })
          }else{
            // form.setFieldsValue({ reportingCases: res.data.maxPalletCapacity });
          }
        }
        if(form.getFieldValue("stockStatus") === "dummy"){
          getRacks(res.data.varientId) //reserve logic commented
        }
        else{
          getRacks(undefined) //reserve logic commented
        }
      
        // getcheckPalletCapacity(res.data,form.getFieldValue("stockStatus"),res.data.varientId);
      } else {
        if (res.intlCode) {
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
        setSaleOrderItemDetails(undefined);
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
      setSaleOrderItemDetails(undefined);
    })
  }
  const getCodeList =(saleOrderId:number)=>{
    codeListMainService.geTracebilityCodeForSoId({saleOrderId:saleOrderId}).then((res) => {
      // console.log(res);
      if (res.status) {
        setTraceCodeList(res.data);
      } else {
        if (res.intlCode) {
          // AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          // AlertMessages.getErrorMessage(res.internalMessage);
        }
        setTraceCodeList([]);
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
      setTraceCodeList([]);
    })
  }

  const getProducts = (val) => {
    const req = new SaleOrderIdRequest(val)
    if(form.getFieldValue('transactionType') == TransactionType.stockTransfer){
      req.productIdArray = stockTransferSoInfo[0].variantId
      req.packStyleIdArray = stockTransferSoInfo[0].packStyleId
    }
    if(form.getFieldValue('soakingOutProduct') != undefined){
      req.soakingOutProduct = form.getFieldValue('soakingOutProduct')
    }
    saleOrderService.getSaleOrderItemsBySaleOrderId(req).then(res => {
      if(res.status){
        setProducts(res.data)
        if(form.getFieldValue('stockStatus') === "anticipated" || form.getFieldValue('stockStatus') === "dummy"){
          getendCustomerAddress(res.data[0].endCustomerId)
        }
      }else{
        setProducts([])
        AlertMessages.getErrorMessage(res.internalMessage)
      }
    })
  }

  const getJobCartonsLoosePouches = () => {
    const req = new CheckSoItemExistReq(null,form.getFieldValue('jobId'))
    if(form.getFieldValue('productId') != undefined){
      req.varientId = form.getFieldValue('productId')
    }
    if(form.getFieldValue('packMethodId') != undefined){
      req.packStyleId = form.getFieldValue('packMethodId')
    }
    stockInService.getJobCartonsLoosePouches(req).then(res => {
      if(res.status){
        if(form.getFieldValue('productId') != undefined && form.getFieldValue('packMethodId') != undefined){
          form.setFieldsValue({reportingCases:res.data[0].jobCartons })
          form.setFieldsValue({loosePouches:res.data[0].jobLoosePouches })
        }
      }
    })
  }


  const checkSoItemExistAgainstJob = () => {
    const req = new CheckSoItemExistReq(null,form.getFieldValue('jobId'))
    if(form.getFieldValue('productId') != undefined){
      req.varientId = form.getFieldValue('productId')
    }
    if(form.getFieldValue('packMethodId') != undefined){
      req.packStyleId = form.getFieldValue('packMethodId')
    }
    stockInService.checkSoItemExist(req).then(res => {
      if(res.status){
        setStockTransferSoInfo(res.data)
       
      }else{
        setStockTransferSoInfo([])
        AlertMessages.getErrorMessage('Job info not found')
      }
    })
  }
  const handleSaleOrder = (value) => {
    
    const transactionType = form.getFieldValue("transactionType");
    const stockType = form.getFieldValue("stockStatus");
  
    if(stockType == StockTypeStatus.dummy){
      getProducts(value)
    }
    
    if ((stockType === "SaleOrder" || stockType === "superDummy") && transactionType != "rm") {
      form.setFieldsValue({ isDamaged: PackingStatus.NO });
    }
    // else if((stockType === "dummy" || stockType === "Anticipated") && transactionType != "rm"){
    //   form.setFieldsValue({ isDamaged: PackingStatus.YES });
    // }
    else{
      form.setFieldsValue({ isDamaged: PackingStatus.NO });
    }

    if (stockType === "SaleOrder" || stockType === "superDummy") {
      form.setFieldsValue({ saleOrderItemId: '' });
      form.setFieldsValue({ reportingCases: 0 });
      // form.setFieldsValue({ rackPostion: null });
      getCodeList(value);
    }
    else if(stockType === "dummy" || stockType === "Anticipated"){
      console.log("dummy Anticipated")
      // getSaleOrderItems(value); // items dropdown

      // getSaleOrderDetails(value)
    }

    if(form.getFieldValue('stockStatus') != StockTypeStatus.dummy){
      getSaleOrderItems(value); // items dropdown
    }

    setSaleOrderId(value);
    form.setFieldsValue({ code : null });

    // getSaleOrderDetails(value);

    // getRacks(undefined); //reserve logic commented
  }
  
  const saveData = (values: any) => {
    setBtnDisable(true)
    if(saveFlag){
      form.validateFields().then(res => {
        let qtyConditionCheckFlag = new Set<boolean>()
        console.log(res);
        console.log(form.getFieldValue('packStyleId'))
        if(res.transactionType == TransactionType.repacking){
          const packStyleRec = packStyle.filter(e => {return(e.packingMethodId == form.getFieldValue('packStyleId'))})
          const reportingQty = (Number(res.reportedCases) * Number(packStyleRec[0].noOfPouches) * Number(packStyleRec[0].pouchesPerRow)) + (Number(res.loosePouches) * Number(packStyleRec[0].pouchesPerRow))
          const totalQty = Number(prevReportedQty) + Number(reportingQty)

          if(totalQty > Number(data.totIssuedQuantity)){
            qtyConditionCheckFlag.add(false)
          }

        }

      if(!(qtyConditionCheckFlag.has(false))){
          if ((res.stockStatus == "dummy" && hideColumns) || res.stockStatus == "Anticipated") {
          // if (res.stockStatus == "Anticipated") {
            // console.log("Dummy Entry");
            // itemform.validateFields().then(itemRes => {
              // console.log(itemRes);
            //   setBtnDisable(true);
    
            //   // if(res.stockStatus === StockTypeStatus.SaleOrder){
            //   //   res.saleOrderItemId = res.SaleOrderItemId;
            //   // }
            //   // else{
            //    res.saleOrderItemId = 0;
            //   // }
    
              // console.log(itemRes.masterBrandId);
            //   let saleOrderItemId = undefined
            //   if (isUpdate) {
            //     saleOrderItemId = saleOrderItemsDetails[0].saleOrderItemId;
            //   }
            //   const itemvalues = new SaleOrderItemsInfo(saleOrderItemId, res.saleOrderId, itemRes.itemId, itemRes.grade.minGrade, itemRes.grade.maxGrade, itemRes.foodTypeId, itemRes.valueAdditionOneId, itemRes.valueAdditionTwoId, itemRes.valueAdditionThreeId, itemRes.valueAdditionFourId, itemRes.valueAdditionFiveId, itemRes.packStyle.pouches, itemRes.cases, itemRes.caseWeight, itemRes.netWeight, itemRes.netAmount, res.createdUser, itemRes.packStyle.pouchWeight, 1, itemRes.Cost, itemRes.Brand, itemRes.WeighingType, itemRes.glazzing.minGlaze, itemRes.glazzing.maxGlaze, itemRes.soakingTime, itemRes.sockingStyleId, itemRes.netwgtcnt, itemRes.varientCode, itemRes.innerBags === undefined ? 0 : itemRes.innerBags, itemRes.shrimpWeight, itemRes.innerBagSizeId === undefined ? 0 : itemRes.innerBagSizeId, itemRes.skewerSizeItemId, itemRes.updatedUser, masterBrandData === undefined ? 1 : masterBrandData,0,itemRes.category,itemRes.requiredCount,itemRes.packStyleId);
              // console.log(itemvalues);
            //   const values = new StockInRequestDto(res.saleOrderId, res.saleOrderItemId, res.reportingCases, res.palletType, res.palletId, res.rackPostion, res.loosePouches, res.lotCode, res.transactionType,res.code, res.coldStorageId, res.plantId, res.shifts, res.packingCompleted, res.stockStatus, res.reportingDate, res.count, itemvalues, isUpdate, res.manualReported, createdUser, createdUser,res.cartonsShortage,res.pouchesShortage,res.productCategory,res.jobId);
              // console.log('values*************')
              // console.log(values);
            //   stockInService.reportStock(values).then((res) => {
            //     if (res.status) {
            //       AlertMessages.getSuccessMessage(res.internalMessage + ' with pallet code =' + res.data.palletCode);
            //       history.push("/fg-stock")
            //       // window.location.reload();
            //     } else {
            //       if (res.intlCode) {
            //         AlertMessages.getErrorMessage(res.internalMessage);
            //       } else {
            //         AlertMessages.getErrorMessage(res.internalMessage);
            //       }
            //     }
            //   }).catch((err) => {
            //     AlertMessages.getErrorMessage(err.message);
            //   })
            // }).catch((err) => {
              // console.log(err);
            //   AlertMessages.getErrorMessage(err.message);
            // });
          }
          else {
            setBtnDisable(true);
            console.log(res);
            const values = new StockInRequestDto(res.saleOrderId, res.saleOrderItemId, res.reportingCases, res.palletType, res.palletId, res.rackPostion ? res.rackPostion : 1, res.loosePouches, res.lotCode,res.transactionType,res.code, res.coldStorageId, res.plantId, res.shifts, res.packingCompleted, res.stockStatus, res.reportingDate, res.count, undefined, isUpdate, res.manualReported, createdUser,createdUser,PackingStatus.NO,PackingStatus.NO,res.productCategory,jobId,res.isDamaged,res.remarks,undefined,0,res.packStyleId,res.palletcode,res.freezer,res.jobCompleted,jobCode,year)
            values.rejectionFrom = form.getFieldValue('rejectionFrom')
            values.gradeChange = gradeChange
            values.soakingOutProduct = form.getFieldValue('soakingOutProduct')
            // console.log('values+++++++++++')
         
          stockInService.reportStock(values).then((res) => {
            if (res.status) {
              AlertMessages.getSuccessMessage(res.internalMessage);
              // openNotification(res.data.palletCode);
              setReportingLogId(res.data.reportingLogId)
              // window.location.reload();
              // history.push("/fg-stock")
              console.log(form.getFieldsValue());
    
              form.setFieldsValue({
                rackPostion: undefined,
                reportingCases:0
              })
    
              setBtnDisable(false);
              getRacks(undefined)
              getTodayStockinInfo()
            } else {
              setBtnDisable(false);
              if (res.intlCode) {
                AlertMessages.getErrorMessage(res.internalMessage);
              } else {
                AlertMessages.getErrorMessage(res.internalMessage);
              }
            }
          }).catch((err) => {
            AlertMessages.getErrorMessage(err.message);
          })
        }
      }else{
        AlertMessages.getErrorMessage('Reported quantity should not exceed issued quantity against job')
      }
      }).catch((err) => {
        // console.log(err);
        AlertMessages.getErrorMessage(err.message);
      });
      
    }else{
      AlertMessages.getErrorMessage('More than 1 product is there for selected product and pack style and customer po')
    }
    

  }
  const getSOsAgainstJob =(value,transactionType)=>{
    forkliftService.getSosAgainstJob({jobId:value,transactionType:transactionType}).then((res) => {
      if(res.status){
        setSaleOrderData(res.data);
      }
      else{
        setSaleOrderData([]);
        if (res.intlCode) {
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch((err) => {
      AlertMessages.getErrorMessage(err.message);
      setSaleOrderData([]);
    });
  }
  const getJobsList =(value)=>{
    if (value == TransactionType.stockTransfer || value == TransactionType.repacking || value == TransactionType.reprocessing || value == TransactionType.rework){
      setLotRequiredState(false)
    }else{
      setLotRequiredState(true)
    }
    let plantId = GlobalVariableValues.productionVersion== 'V1' ? Number(localStorage.getItem("unit_id")) : form.getFieldValue('unitId');
    form.setFieldsValue({jobId : null})
    form.setFieldsValue({saleOrderId:null})
    form.setFieldsValue({saleOrderItemId:null})
    console.log(plantId);
    if(value == TransactionType.Labsamples){
      form.setFieldsValue({'stockStatus' : StockTypeStatus.dummy})
      getDummySaleOrdersData(plantId);
      setStockTypeDisable(true)
    }else{
      setStockTypeDisable(false)
    }
    if(value!=='rm' && value !== 'stockTransfer'){
      forkliftService.getForkliftJobCodes({unitId:plantId,transactionType:value}).then((res) => {
        if (res.status) {
          // console.log(res.data);
          if(res.data.length>0){
            setJobcodesData(res.data);
          }else{
            setJobcodesData([]);
          }
          
          setHidejobType(false);
          setIsJobcodeRequired(true);
        } else {
          setHidejobType(false);
          setIsJobcodeRequired(false);
          if (res.intlCode) {
            AlertMessages.getErrorMessage(res.internalMessage);
          } else {
            AlertMessages.getErrorMessage(res.internalMessage);
          }
         setJobcodesData([]);
        }
      }).catch((err) => {
        AlertMessages.getErrorMessage(err.message);
        setJobcodesData([]);
      });
    }
    if(value=='stockTransfer'){
      forkliftService.getForkliftJobCodes({unitId:plantId,transactionType:'stockTransfer'}).then((res) => {
        if (res.status) {
          // console.log(res.data);
          if(res.data.length>0){
            setJobcodesData(res.data);
          }else{
            setJobcodesData([]);
          }
          
          setHidejobType(false);
          setIsJobcodeRequired(true);
        } else {
          setHidejobType(false);
          setIsJobcodeRequired(false);
          if (res.intlCode) {
            AlertMessages.getErrorMessage(res.internalMessage);
          } else {
            AlertMessages.getErrorMessage(res.internalMessage);
          }
         setJobcodesData([]);
        }
      }).catch((err) => {
        AlertMessages.getErrorMessage(err.message);
        setJobcodesData([]);
      });
    }
    else{
      setHidejobType(true);
    }
  }
  const handleStockType = (value) => {
    console.log(value);
    form.setFieldsValue({'reportingCases': 0});
    if(value=='superDummy'){
      setHidePackStyle(true)
    }
    else{
      setHidePackStyle(false)
    }
    const transactionType = form.getFieldValue("transactionType");
    const unitId = GlobalVariableValues.productionVersion == 'V1' ? localStorage.getItem("unit_id") : form.getFieldValue('unitId')
    if((transactionType === "repacking" || transactionType === "reprocessing") && (value === "SaleOrder" || value === "superDummy")){
      getJobsList(transactionType);
    }
    else if((transactionType === "repacking" || transactionType === "reprocessing") && (value === "dummy" || value === "Anticipated")){getDummySaleOrdersData(unitId)
    } 

    if ((value === "SaleOrder" || value === "superDummy") && transactionType != "rm") {
      form.setFieldsValue({ isDamaged: PackingStatus.NO });
    }
    // else if((value === "dummy" || value === "Anticipated") && transactionType != "rm"){
    //   form.setFieldsValue({ isDamaged: PackingStatus.YES });
    // }

    form.setFieldsValue({ saleOrderId: null })
    form.setFieldsValue({ saleOrderItemId: null })
    setSaleOrderItemDetails(undefined)
    setStockStatus(value);
    setStockStatus(value);
    if(value === StockTypeStatus.dummy || value === StockTypeStatus.Anticipated){
      setIsTracecodeRequired(false);
    }
    else if(value === StockTypeStatus.SaleOrder || value === StockTypeStatus.superDummy){
      setIsTracecodeRequired(true);
    }
    if(value === StockTypeStatus.superDummy || value === StockTypeStatus.Anticipated){
      form.setFieldsValue({pouchesShortage : PackingStatus.YES})
      form.setFieldsValue({cartonsShortage : PackingStatus.YES})
    }
    else{
      form.setFieldsValue({pouchesShortage : PackingStatus.NO})
      form.setFieldsValue({cartonsShortage : PackingStatus.NO})
    }
    if (value === StockTypeStatus.dummy || value === StockTypeStatus.Anticipated) {
      // setHideColumns(true);
      setItemValidation(false);
      form.setFieldsValue({ packingCompleted: PackingStatus.NO })
      getDummySaleOrdersData(unitId);
    }
    else
      if (value == StockTypeStatus.SaleOrder) {
        // console.log(value + '===' + StockTypeStatus);
        form.setFieldsValue({ packingCompleted: PackingStatus.YES })
        setHideColumns(false);
        setItemValidation(true);
        console.log('======================================')
        getSaleOrderData(unitId);
      } else {
        form.setFieldsValue({ packingCompleted: PackingStatus.NO })
        setHideColumns(false);
        setItemValidation(true);
        console.log(']]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]')
        getSaleOrderData(unitId);
      }
      getRacks(undefined); //reserve logic commented
  }
  const handleSaleOrderItem = (value) => {
    // console.log(`selected ${value}`);
    getSaleOrderItemDetails(value);
  }
  const clearDependentFields = () => {
    form.setFieldsValue({ saleOrderId: null })
    form.setFieldsValue({ saleOrderItemId: null })
    form.setFieldsValue({ TransactionType: null })
    form.setFieldsValue({ jobId: null })
  }
  const handleColdStorage = (value) => {
    // getRacks(value);

  }
  const handlePackStyle = (value) => {
    console.log(value);
    console.log(packStyle.find(rec => rec.packingMethodId === value));
    // form.setFieldsValue({'reportingCases': packStyle.find(rec => rec.packingMethodId === value).maxPalletCapacity});
    getRacks(undefined);
  }
  const onReset = () => {
    form.resetFields();
  };
  const openNotification = (content) => {
    notification.open({
      message: 'Pallet Code',
      description:
        'Stock updated with pallet code' + content,
      // duration: 0, 
      onClick: () => {
        // console.log('Notification Clicked!');
      },
    });
  };
  const openReserveNotification = (content) => {
    if(content != null){
      notification.open({
        message: '',
        description: content,
        // duration: 1,
        onClick: () => {
          // console.log('Notification Clicked!');
        },
      });
    }
  };

  const handleOk = () => {
    setIsModalVisible(false);
    getSaleOrderItems(saleOrderId)
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    getSaleOrderItems(saleOrderId)
  };
  const handleJobcodes =(content,option)=>{
    setJobCode(option?.jobCode)
    let transactionType = form.getFieldValue("transactionType");
    const unitId = GlobalVariableValues.productionVersion == 'V1' ? localStorage.getItem("unit_id") : form.getFieldValue('unitId')
    // if(transactionType!=='rm' && transactionType !== 'stockTransfer'){
    if(transactionType == TransactionType.repacking){
      getSOsAgainstJob(content,transactionType);
    }else if (transactionType == TransactionType.Labsamples){
      getDummySaleOrdersData(unitId)
    }
    else{
      console.log('................................................')
      getSaleOrderData(unitId)
    }


    if(transactionType == TransactionType.stockTransfer){
      checkSoItemExistAgainstJob()
    }
    // }

    // console.log('content'+content)
    setJobId(content);
    
  }
  function onBlur() {
    // console.log('blur');
  }

  function onFocus() {
    // console.log('focus');
  }

  function onSearch(val) {
    // console.log('search:', val);
  }

  const printModalOpen =() => {
    
    setIsModalVisible(true); // model should be open
    setModalName('print')
  }

  const onProductChange = (val) => {
    const req = new SOVarientIdReq(form.getFieldValue('saleOrderId'),val)
    if(form.getFieldValue('transactionType') == TransactionType.stockTransfer){
      req.packStyleId = stockTransferSoInfo[0].packStyleId
    }
    saleOrderService.getSoItemPackStyle(req).then(res => {
      if(res.status){
        setDummyProductPackStyles(res.data)
        form.setFieldsValue({packMethodId : null})
      }else{
        AlertMessages.getErrorMessage(res.internalMessage)
      }
    })
  }

  const onPackMethodChange = () => {
    form.setFieldsValue({'reportingCases':undefined,'loosePouches':undefined})
    getSaleOrderItems(form.getFieldValue('saleOrderId'))
    getJobCartonsLoosePouches()
  }

  const onUnitChange = (val) => {
    getTodayStockinInfo()
    getSaleOrderData(val);
    getPackStyles(val);
    form.setFieldsValue({plantId:val})
  }

  const onLotCodeChange = (val,option) => {
    setYear(option?.year)
    getProductsAgainstLotCount()
  }

  const onProductCategoryChange = (val,option) => {
    setSelectedProductCategory(option?.productCategoryName)
    if(option?.productCategoryName == ProductCategoryEnum.rj){
      getSoakingOutProductsInfo()
    }
    if(option?.productCategoryName == ProductCategoryEnum.RRP){
      getRejectionFromProductsInfo()
    }
  }

  const onGradeChange = (e) => {
    form.setFieldsValue({'soakingOutProduct':undefined})
    setGradeChange(e.target.value)
    if(e.target.value){
      getProductsAgainstLotCount()
    }else{
      getProducts(form.getFieldValue('saleOrderId'))
    }
  }

  const onSoakingOutProductChange = () => {
    getProducts(form.getFieldValue('saleOrderId'))
  }

  return (
    <>
      <Card
        title={<span style={{ color: 'white' }}> Stock In</span>}
        style={{ textAlign: 'center' }}
        headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
        extra={
          <>
          <Link to="/fg-excel-upload">
            <Button>Excel Upload</Button>
          </Link>
          <Link to="/fg-stock">
            <Button >View </Button>
          </Link>
          </>
        }

      >
        <Form
          layout="vertical"
          form={form}
          name="control-hooks"
          onFinish={saveData}
        >
          <Form.Item
            style={{ display: 'none' }}
            name="createdUser"
            initialValue={createdUser}
          >
            <Input hidden />
          </Form.Item>
          <Form.Item style={{ display: "none" }} name="targetPosition" >
            <Input hidden />
          </Form.Item>
          <Form.Item style={{ display: "none" }} name="manualReported" initialValue={true}>
            <Input hidden />
          </Form.Item>
          <Form.Item style={{ display: "none" }} name="currentPosition" >
            <Input hidden />
          </Form.Item>
          <Form.Item style={{ display: "none" }} name="palletType" initialValue={PalletType.new}>
            <Input hidden />
          </Form.Item>
          
          <Form.Item style={{ display: "none" }} name="plantId" initialValue={Number(localStorage.getItem('unit_id'))}>
            <Input hidden />
          </Form.Item>
          
          <Form.Item style={{ display: "none" }} name="palletId" initialValue={1}>
            <Input hidden />
          </Form.Item>
          
          <Row gutter={24}>
            {
              GlobalVariableValues.productionVersion == 'V2' ? (<>
              
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 8 }} lg={{ span: 6 }} xl={{ span: 4 }}>
                <Form.Item name="unitId" label="Unit" 
                  rules={[
                    {
                      required: true, message: 'Missing Unit',
                    },
                  ]}
                >
                  <Select
                  showSearch
                  optionFilterProp="children"
                  placeholder="Select Unit"
                  allowClear
                  onChange={onUnitChange}
                >
                  {
                    unitCodes.map(e => {
                      return(
                        <Option key={e.plantId} value={e.plantId}>{e.plantCode}</Option>
                      )
                    })
                  }
                </Select>
                </Form.Item>
              </Col>
              </>) : (<></>)
            }
          <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}}>
            <Form.Item name="reportingDate" label = "Date" initialValue={moment()}
            rules={[
              {
                required: true, message: 'Missing Date',
              },
            ]}
            >
              <DatePicker disabledDate={(current) => current.isAfter(moment())} showTime={{ format: "HH:mm" }} style={{ width: '100%' }} format="YYYY-MM-DD HH:mm:ss"
                showToday={true} defaultValue={moment('YYYY-MM-DD HH:mm:ss')} />
            </Form.Item>
          </Col>
            
        
          <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}}>
              <Form.Item
                name="transactionType"
                label="Transaction Type"
                initialValue={TransactionType.rm}
                rules={[
                  {
                    required: true, message: 'Missing Transaction Type',
                  },
                ]}

              >
                <Select
                  // placeholder="Select Transaction Type"
                   onChange={getJobsList}
                  // defaultValue="rm"
                  allowClear
                  onClear={clearDependentFields}
                >
                  {transactionTypeDropDown.map(transactionType => {
                    return <Option value={transactionType.value}>{transactionType.name}</Option>
                  })}
                </Select>
              </Form.Item>
            </Col>
            {  !hidejobType  ?
            <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}}>

              <Form.Item
                name="jobId"
                label="Job Code"
                rules={[
                  {
                    required: isJobcodeRequired, message: 'Missing Job code',
                  },
                ]}
              >
                <Select
                  placeholder="Select Jobcode"
                  onChange={handleJobcodes}
                  allowClear
                  showSearch
                  // onFocus={onFocus}
                  // onBlur={onBlur}
                  onSearch={onSearch}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  <Option value={null}>Please select</Option>
                  {jobcodesData.map(jobcodesDropdown => {
                    return <Option value={jobcodesDropdown.jobId} jobCode = {jobcodesDropdown.jobCode}>{jobcodesDropdown.jobCode}</Option>
                  })}
                </Select>
              </Form.Item>
            </Col>:""}
            <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}}>
              <Form.Item
                name="stockStatus"
                label="Stock Type"
                rules={[
                  {
                    required: true, message: 'Missing Stock Type',
                  },
                ]}

              >
                <Select
                  placeholder="Select Stock Type"
                  onChange={handleStockType}
                  allowClear
                  onClear={clearDependentFields}
                  disabled={form.getFieldValue('transactionType') == StockTypesEnum.RE_PACK || data?.jobPurpose == 'labsamples' || form.getFieldValue('transactionType') == TransactionType.Labsamples ? true : false}
                >
                  {/* <Option value="0">Please select StockType</Option> */}
                  <Option value={undefined}>Please select StockType</Option>
                  {stockType.map(stockType => {
                    return <Option value={stockType.value}>{stockType.name}</Option>
                  })}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}}>
              <Form.Item
                name="saleOrderId"
                label="Customer PO"
                rules={[
                  {
                    required: true, message: 'Missing Sale Order',
                  },
                ]}
              >
                <Select
                  placeholder="Select Customer Po"
                  onChange={handleSaleOrder}
                  allowClear
                  showSearch
                  onFocus={onFocus}
                  onBlur={onBlur}
                  onSearch={onSearch}
                  optionFilterProp='children'
                  // filterOption={(input, option) =>
                  //   option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  // }
                >
                  {saleOrderData.map(saleOrderDropDown => {
                    return <Option value={saleOrderDropDown.saleOrderId}>{saleOrderDropDown.saleOrderNumber}</Option>
                  })}
                </Select>
              </Form.Item>
            </Col>
            
            <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}}  >
              <Form.Item name="lotCode" label="Lot Code"
                rules={[
                  {
                    required: lotRequiredState,
                    // (form.getFieldValue('transactionType') != TransactionType.repacking || form.getFieldValue('transactionType') != TransactionType.stockTransfer) ? true : false,
                    message: 'Missing Lot Code',
                  },
                ]} >
                    <Select
                  placeholder="Select Lot Code"
                  allowClear
                  showSearch
                  onChange={onLotCodeChange}
                >
                  {/* <Option value="0">Please select StockType</Option> */}
                  <Option value={undefined}>Please select Lot code</Option>
                  {lotCodes.map(stockType => {
                    return <Option value={stockType.plantLotNumber} year={stockType.year}>{stockType.plantLotNumber}-{stockType.year}</Option>
                  })}
                </Select>
              </Form.Item>
            </Col>

            {
              isTracecodeRequired?
              <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}}>

              <Form.Item
                name="code"
                label="Trace Code"
                rules={[
                  {
                    required: false, message: 'Missing Trace Code',
                  },
                ]}
              >
                <Select
                  placeholder="Select Trace Code"
                  // onChange={handleSaleOrder}
                  allowClear
                  showSearch
                  onFocus={onFocus}
                  onBlur={onBlur}
                  onSearch={onSearch}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  <Option value={null}>select Trace Code</Option>
                  {traceCodeList.map(res => {
                    return <Option value={res.tracebilityCodeId}>{res.tracebilityCode}</Option>
                  })}
                </Select>
              </Form.Item>
            </Col>
            :""
            }
            {/* lll */}
            <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:12}} xl={{span:4}}>
              <Form.Item name='gradeChange' label='Grade Change' initialValue={false} rules={[{required:true,message:'Grade Change is required'}]}>
              <Radio.Group onChange={onGradeChange} defaultValue={false}>
                  <Radio value={true}>YES</Radio>
                  <Radio value={false}>NO</Radio>
              </Radio.Group>
              </Form.Item>
            </Col>
            {
              gradeChange ? (<>
                <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:12}} xl={{span:4}}>
                  <Form.Item name='soakingOutProduct' label='Soaking Product' rules={[{required:true,message:'Soaking Product is required'}]}>
                    <Select allowClear showSearch optionFilterProp='children' placeholder='Select Soaking Out Product' onChange={onSoakingOutProductChange}>
                      {
                        soakingOutProducts.map(e => {
                          return(
                            <Option name={e.product} value={e.product}>{e.product}</Option>
                          )
                        })
                      }
                    </Select>
                  </Form.Item>
                </Col>
              </>) : (<></>)
            }

            {
              form.getFieldValue('stockStatus') == StockTypeStatus.dummy ? (<>
                <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:12}} xl={{span:4}}>
                  <Form.Item
                    name="productId"
                    label="Product"
                    rules={[
                      {
                        required: form.getFieldValue('stockStatus')  == StockTypeStatus.dummy ? true : false, message: 'Missing Product',
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select Product"
                      onChange={onProductChange}
                      allowClear
                      showSearch
                      optionFilterProp='children'
                    >
                      {products?.map(e => {
                        return <Option value={e.productId}>{e.product}</Option>
                      })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:12}} xl={{span:4}}>
                  <Form.Item
                    name="packMethodId"
                    label="Pack Style"
                    rules={[
                      {
                        required: form.getFieldValue('stockStatus')  == StockTypeStatus.dummy ? true : false, message: 'Missing Pack Style',
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select Pack Style"
                      onChange={onPackMethodChange}
                      allowClear
                      showSearch
                      optionFilterProp='children'
                    >
                      {dummyProductPackStyles?.map(e => {
                        return <Option value={e.packMethodId}>{e.packMethodName}</Option>
                      })}
                    </Select>
                  </Form.Item>
                </Col>
              
              </>) : (<></>)
            }
         
            
            {
              !hideColumns ?
              <>
                <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:12}} xl={{span:5}}>
                  <Form.Item
                    name="saleOrderItemId"
                    label="SO Item"
                    rules={[
                      {
                        required: itemValidation, message: 'Missing Sale Order Item',
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select Sale Order Item"
                      onChange={handleSaleOrderItem}
                      allowClear
                      showSearch
                      onFocus={onFocus}
                      onBlur={onBlur}
                      onSearch={onSearch}
                      optionFilterProp='children'
                      disabled={form.getFieldValue('stockStatus') == StockTypeStatus.dummy ? true : false}
                      // filterOption={(input, option) =>
                        
                      //   option.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      // }
                    >
                      {/* <Option value={null}>select SO Item</Option> */}
                      {saleOrderItemsData?.map(saleOrderDropDown => {
                        return <Option value={saleOrderDropDown.saleOrderItemId}>{saleOrderDropDown.varient}</Option>
                      })}
                    </Select>
                  </Form.Item>
                </Col>
              </>
                : ""
            }
            {
              hidePackStyle?
              <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}}>
                <Form.Item name="packStyleId" label="Pack Style"
                  rules={[
                    {
                      required: hidePackStyle, message: 'Missing Pack Style',
                    },
                  ]}>
                  <Select
                    placeholder="Select Pack Style"
                    onChange={handlePackStyle}
                    allowClear
                  >
                    {packStyle?.map(dropdown => {
                      return <Option value={dropdown.packingMethodId}>{dropdown.packingMethodName}</Option>
                    })}
                  </Select>
                </Form.Item>
              </Col>
              :""
            }
        
            {
              (form.getFieldValue("stockStatus") === StockTypeStatus.dummy || form.getFieldValue("stockStatus") === StockTypeStatus.Anticipated) && form.getFieldValue("saleOrderId")?
                <Col span={4} style={{paddingTop:'30px'}}>
                  <Button type="primary" hidden={false} onClick={() =>{setIsModalVisible(true); setModalName('items')}} style={{ backgroundColor: '#40a9ff' }}>+Add New Product</Button>
                </Col>
              :""
            }
            <Modal
              title="Add Product"
              key={'modal' + Date.now()}
              width={'80%'}
              style={{ top: 30, alignContent: 'right' }}
              visible={isModalVisible}
              onCancel={handleCancel}
              footer={[
              ]}>
             { modalName == 'items' ? <ItemDetailsForm key={itemsKey} mastesrBrandData={mastesrBrandData} 
              // getVarientId={handleVarientId} 
              brandsData={customerBrandsData} category={selectedCategory} 
              // initialData={saleOrderItemsDetails} 
              soStatus={saleOrderDetails?.soStatus} packCategory={saleOrderDetails?.category} currency={selectedCurrency} updateCurrency={saleOrderDetails?.currencyId} stockStatus={stockStatus} saleOrderId={form.getFieldValue("saleOrderId")} closeModal={handleOk} varientsData={saleOrderItemsData} /> : <StockinPrint  reportingLogId={reportingLogId}/>
            }</Modal>

            <Col xs={{span:12}} sm={{span:12}} md={{span:4}} lg={{span:3}} xl={{span:4}}>
              <Form.Item name="reportingCases" label="Master Cartons"

                rules={[
                  {
                    required: true,
                    message: 'Missing Reporting Cases',
                    validator: (_, value) =>
                      value >= 0 ? Promise.resolve() : Promise.reject(new Error('Enter only positive values')),
                  },
                ]}>
                <Input type='number' min={(0)}
                // onBlur={e => plant === '3' ? getRacks(varientId):null} //reserve logic commented
                onBlur={() => {getRacks(varientId)}}
                />
              </Form.Item>
            </Col>
            
            <Col xs={{span:12}} sm={{span:12}} md={{span:4}} lg={{span:3}} xl={{span:4}}>
              <Form.Item name="loosePouches" label="Loose Pouches"
                initialValue={0}>
                <Input type='number' min={(0)}/>
              </Form.Item>
            </Col>

            <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}}>
              <Form.Item
                name="shifts"
                label="Shift"
                rules={[
                  {
                    required: true, message: 'Missing Shift',
                  },
                ]}
                // initialValue={shifts[0].value}
                initialValue="General"
               
              >
                <Select
                  placeholder="Select Shifts"
                  allowClear
                >
                  {/* {shifts.map(shift => {
                    return <Option value={shift.value}>{shift.name}</Option>
                  })} */}
                   <Option key={'General'} value={'General'}>General</Option>
                  <Option key={'DAY'} value={'DAY'}>Day</Option>
                  <Option key={'NIGHT'} value={'NIGHT'}>Night</Option>
                </Select>
              </Form.Item>
            </Col>

            <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}}>
              <Form.Item name="freezer" label="Freezer" 
                rules={[
                  {
                    required: false, message: 'Missing freezer',
                  },
                ]}>
               <Select
                placeholder="Select Freezer"
                allowClear
              // disabled={userName != 'rmmanager'}
              >
                {/* <Option value={null || 0}>Select Farm Type</Option> */}
                {Object.values(FreezerTypesEnum).map((i) => {
                return (
                  <Option key={i} value={i}>
                    {i}
                  </Option>
                );
              })}

              </Select>         
              </Form.Item>
            </Col>

            <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}}>
              <Form.Item name="whIncharge" label="WH Incharge"
                rules={[
                  {
                    required: true, message: 'Missing WH Incharg',
                  },
                ]}
              >
                 <Select
                  placeholder="Select WH Incharge"
                  // onChange={handleSaleOrder}
                  allowClear
                  showSearch
                  onFocus={onFocus}
                  onBlur={onBlur}
                  onSearch={onSearch}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {employeeData.map(dropData => {
                  return <Option value={dropData.employeeName}>{`${dropData.employeeName}`}</Option>
                })}
                </Select>
              </Form.Item>
            </Col>

            
            {/* commented for BMR as in all plants BMR assigned to locations{
              hideRackColumns? */}
                <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}}>
                  <Form.Item
                    name="rackPostion"
                    label="Rack Position"
                    rules={[
                      {
                        required: true, message: 'Missing Rack Position',
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select Rack Position"
                      // onChange={handleSaleOrder}
                      allowClear
                      showSearch
                      onFocus={onFocus}
                      onBlur={onBlur}
                      onSearch={onSearch}
                      filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      <Option value={undefined}>Select Rack Position</Option>
                      {rackPostionsDropDown.map(res => {
                        return <Option value={res.rackPositionId}>{res.rackCode}</Option>
                      })}
                    </Select>
                  </Form.Item>
                </Col>
                {/* :""
            } */}

            <Col>
              <Form.Item name="isDamaged" label="Is Damaged?"
                rules={[
                  {
                    required: true, message: 'Missing Damage Status',
                  },
                ]}
                hidden
              >
                <Select
                  placeholder="Select Damage Status"
                  allowClear
                  defaultValue={PackingStatus.NO}
                  disabled
                >
                  <Option value="null">Select Damage Status</Option>
                  <Option value={PackingStatus.NO}>{PackingStatus.NO}</Option>
                  <Option value={PackingStatus.YES}>{PackingStatus.YES}</Option>
                </Select>
              </Form.Item>
            </Col>
            {  !hidejobType  ?
            <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}}>

              <Form.Item
                name="jobCompleted"
                label="Job Completed"
                rules={[
                  {
                    required: isJobcodeRequired, message: 'Missing Job code',
                  },
                ]}
              >
                <Radio.Group name = 'jobCompleted'>
                <Radio value={true}>Yes</Radio>
                <Radio value={false}>NO</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>:""}
          
         
            
          {/* </Row> */}
          

          {!hideColumns && saleOrderItemDetails != undefined ?
            <Row gutter={24}>
              <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:24}}>
             
              {saleOrderItemDetails ?
                <Descriptions column={{ xxl: 4, xl: 4, lg: 4, md: 3, sm: 2, xs: 2 }}>
                  {/* <Descriptions.Item 
                  label="Brand"
                  >
                    {saleOrderItemDetails.brand ? saleOrderItemDetails.brand : ''}
                  </Descriptions.Item>
                  <Descriptions.Item label="Product">
                    {saleOrderItemDetails.product ? saleOrderItemDetails.product : ''}
                  </Descriptions.Item>
                  <Descriptions.Item label="Varient">
                    {saleOrderItemDetails.varient ? saleOrderItemDetails.varient : ''}
                  </Descriptions.Item>
                  <Descriptions.Item label="Grade">
                    {saleOrderItemDetails.minGrade ? saleOrderItemDetails.minGrade + '-' + saleOrderItemDetails.maxGrade : ''}
                  </Descriptions.Item> */}
                  {/* <Descriptions.Item label="Uom" >
                    {saleOrderItemDetails.uom ? saleOrderItemDetails.uom : ''}
                  </Descriptions.Item> */}
                   <Descriptions.Item  label="Brand" style={{paddingLeft:'10px'}} >
                    {saleOrderItemDetails.brand ? saleOrderItemDetails.brand: ''}
                  </Descriptions.Item>
                  <Descriptions.Item  label="Pack Style" style={{paddingLeft:'10px'}} >
                    {saleOrderItemDetails.packingStyle ? saleOrderItemDetails.packingStyle + " " + saleOrderItemDetails.uom : ''}
                  </Descriptions.Item>
                  <Descriptions.Item label="Glazing">
                    {saleOrderItemDetails.maxGlaze ? saleOrderItemDetails.maxGlaze + '-' + saleOrderItemDetails.maxGlaze : ''}
                  </Descriptions.Item>
                  <Descriptions.Item label="Soak Style" style={{paddingLeft:'10px'}}>
                    {saleOrderItemDetails.soakingStyle ? saleOrderItemDetails.soakingStyle : ""}
                  </Descriptions.Item>
                  <Descriptions.Item label="Soak Time" style={{paddingLeft:'10px'}}>
                    {saleOrderItemDetails.soakingTime ? saleOrderItemDetails.soakingTime : ""}
                  </Descriptions.Item>
                  <Descriptions.Item label="Cases Req.">
                    {saleOrderItemDetails.jobCases ? saleOrderItemDetails.jobCases : ''}
                  </Descriptions.Item>
                  <Descriptions.Item label="Reported Cases" style={{paddingLeft:'10px'}}>
                    {saleOrderItemDetails.reportedCases ? saleOrderItemDetails.reportedCases : 0}
                  </Descriptions.Item>
                  <Descriptions.Item label="Pallet Capacity" style={{paddingLeft:'10px'}}>
                    {saleOrderItemDetails.palletCapacity ? saleOrderItemDetails.palletCapacity : 0}
                  </Descriptions.Item>
                </Descriptions>
                : ""}
                 </Col>
            </Row>
            : ""}
          {/* {
            hideColumns && saleOrderId > 0 ?
              // <Row gutter={24}>
                <ItemDetailsForm key={itemsKey} form={itemform} addDataToItemDetails={addDataToItemDetails} mastesrBrandData={mastesrBrandData} getVarientId={handleVarientId} brandsData={customerBrandsData} category={selectedCategory} initialData={saleOrderItemsDetails} soStatus={saleOrderDetails?.soStatus} packCategory={saleOrderDetails?.category} currency={selectedCurrency} updateCurrency={saleOrderDetails?.currencyId} stockStatus={stockStatus} />
              // </Row> 
              : ""
          } */}

          {/* <Row gutter={24}> */}
            <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}} hidden>
              <Form.Item name="coldStorageId" label="Cold Storage"
                rules={[
                  {
                    required: false, message: 'Missing Cold Storage',
                  },
                ]}>
                <Select
                  placeholder="Select Cold Storage"
                  onChange={handleColdStorage}
                  allowClear
                >
                  {zoneDropDown?.map(dropdown => {
                    return <Option value={dropdown.zoneId}>{dropdown.zoneName}</Option>
                  })}
                </Select>
              </Form.Item>
            </Col>
            
            <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}} hidden>
              <Form.Item name="packingCompleted" label="Packing Completed"
                rules={[
                  {
                    required: true, message: 'Missing Packing Status',
                  },
                ]}
              // initialValue={PackingStatus.NO}
              >
                {/* <Input/> */}
                <Select
                  placeholder="Select packing Status"
                  allowClear
                  defaultValue={PackingStatus.NO}
                >
                  <Option value="null">Select Packing Status</Option>
                  <Option value={PackingStatus.NO}>{PackingStatus.NO}</Option>
                  <Option value={PackingStatus.YES}>{PackingStatus.YES}</Option>
                </Select>
              </Form.Item>
            </Col>
            {/* <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}}>
              <Form.Item name="pouchesShortage" label="Is Pouches Shortage?"
                rules={[
                  {
                    required: true, message: 'Missing Pouches Status',
                  },
                ]}
              >
                <Select
                  placeholder="Select Pouches Status"
                  allowClear
                  defaultValue={PackingStatus.NO}
                  disabled
                >
                  <Option value={PackingStatus.NO}>{PackingStatus.NO}</Option>
                  <Option value={PackingStatus.YES}>{PackingStatus.YES}</Option>
                </Select>
              </Form.Item>
            </Col> */}
            {/* <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}}>
              <Form.Item name="cartonsShortage" label="Is Cartons Shortage?"
                rules={[
                  {
                    required: true, message: 'Missing Cartons Status',
                  },
                ]}
              >
                <Select
                  placeholder="Select Cartons Status"
                  allowClear
                  defaultValue={PackingStatus.NO}
                  disabled
                >
                  <Option value={PackingStatus.NO}>{PackingStatus.NO}</Option>
                  <Option value={PackingStatus.YES}>{PackingStatus.YES}</Option>
                </Select>
              </Form.Item>
            </Col> */}
            <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}} hidden>
              <Form.Item name="count" label="Grade"
                rules={[
                  {
                    required: false,
                    message: 'Missing Grade',
                    validator: (_, value) =>
                      value >= 0 ? Promise.resolve() : Promise.reject(new Error('Enter only positive values')),
                  },
                ]} initialValue={0}>
                <Input type='number'
                />
              </Form.Item>
            </Col>
            <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}}>
              <Form.Item
                name="productCategory"
                label="Product Category"
                rules={[
                  {
                    required: true, message: 'Missing Product Category',
                  },
                ]}
              >
                <Select
                  placeholder="Select Product Category"
                  allowClear
                  showSearch
                  optionFilterProp='children'
                  onChange={onProductCategoryChange}
                >
                  {categories.map(item => {
                    return <Option value={item.value} productCategoryName={item.name}>{item.name}</Option>
                  })}
                </Select>
              </Form.Item>
            </Col>
            {
              selectedProductcategory == ProductCategoryEnum.rj || selectedProductcategory == ProductCategoryEnum.RRP? (
                <>
                  <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}}>
                    <Form.Item name='rejectionFrom' label='Rejection From' rules={[{required:true,message:'Rejection From Product is required'}]}>
                      <Select allowClear showSearch optionFilterProp='children' placeholder='Select rejection from product'>
                        {
                          rejectionFromProducts.map(e => {
                            return(
                              <Option key={e.rejectionFrom} value={e.rejectionFrom}>{e.rejectionFrom}</Option>
                            )
                          })
                        }
                      </Select>
                    </Form.Item>
                  </Col>
                </>
              ) : (<></>)
            }
           
            <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}}>
              <Form.Item name="palletcode" label="Pallet Code" 
                rules={[
                  {
                    required: false, message: 'Missing Pallet',
                  },
                ]}>
                <Input />
              </Form.Item>
            </Col>
          
            <Col span={7}>
              <Form.Item name="remarks" label="Remarks">
                  <TextArea showCount  />
              </Form.Item>
            </Col>
          
          </Row>
          <Row>
          <Col>
            <Button type="primary" htmlType="submit" block disabled={btnDisable}>
              Submit
            </Button>
            </Col>
            <Col>
            <Button
              htmlType="button"
              style={{ margin: '0 14px' }}
              onClick={onReset}
            >
              Reset
            </Button>
          </Col>
          <Col hidden={reportingLogId?false:true}>
            <Button type="primary" onClick={printModalOpen} >
              Print previous transaction
            </Button>
            </Col>
          </Row>
        </Form>
        <br/>
        {
          todayStockInInfo.length > 0 ? (<>
          <Row gutter={24}>
          <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:24}}>
          <Table columns={columns} dataSource={todayStockInInfo}/>
          </Col>
          </Row>
          </>) : (<></>)
        }
        
      </Card>
    </>
  );
}

export default StockInForm;
